import React from "react";
import { Container, Row, Form, Button } from "react-bootstrap";

import moment from 'moment';

import academicPeriodsService from "presentation/services/academic-periods";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import AcademicPeriodSchoolDaysForm from 'presentation/pages/academic-periods/elements/school_days_form';

import { handleChange } from "presentation/utils/functions/generic";


class AcademicPeriodSchoolDaysManagement extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      form: {},
      academicPeriod: { name: '', startDate: '', endDate: '' },
      schoolDays: [],
      actionLoading: false,
      error: false,
      message: '',
    };
    this.loadData = this.loadData.bind(this);

  }

  async componentDidMount() {
    const { id } = this.props.match.params
    await this.loadData(id);
  }

  loadData = async (id) => {
    await academicPeriodsService.findById(id).then(async (result) => {

      if (result.startDate != null) {
        result.startDate = moment(result.startDate, 'YYYY-MM-DD').format("YYYY-MM-DD");
      }

      if (result.endDate != null) {
        result.endDate = moment(result.endDate, 'YYYY-MM-DD').format("YYYY-MM-DD");
      }
      await academicPeriodsService.findSchoolDaysCalendar(id).then((eventInfos) => {
        this.setState({ schoolDays: eventInfos });
      });
      this.setState({ academicPeriod: result, loading: false });
    });

  }

  goTo = (destination) => {
    const { history } = this.props;

    history.push(destination);
  };

  handleSubmit = async () => {

    this.setState({ loading: true, actionLoading: true, error: '' });

    const {
      schoolDays,
    } = this.state;

    if (!schoolDays) {
      this.setState({ loading: false, error: true, message: "Por favor, configure o calendário de dias letivos corretamente..." });
    } else {
      let postData = { schoolDays: this.state.schoolDays };
      try {
        const response = await academicPeriodsService.saveSchoolDays(postData);
        if (response.error == true) {
          this.setState({
            loading: false,
            actionLoading: false,
            error: true,
            message: response.message
          });
        } else {

          this.goTo("/periodos-academicos");
        }
      } catch (err) {
        this.setState({
          loading: false,
          actionLoading: false,
          error: true,
          message: err.message
        });
      }
    }
  };

  render() {
    let { location } = this.props;
    let { loading, error, message, actionLoading, academicPeriod, schoolDays } = this.state;
    let { handleSubmit } = this;

    let isSystemGenerated = schoolDays[0] && schoolDays[0].isSystemGenerated == true;

    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && (
          <Container >
            <Row>
              <AcademicPeriodSchoolDaysForm
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                loading={loading}
                academicPeriod={academicPeriod}
                isSystemGenerated={isSystemGenerated}
                component={this}
              />
            </Row>
          </Container>
        )
        }
      </div>
    );
  };
}

export default AcademicPeriodSchoolDaysManagement;
